import { render } from "./EdiSelector.vue?vue&type=template&id=3f2743d8&scoped=true"
import script from "./EdiSelector.vue?vue&type=script&lang=js"
export * from "./EdiSelector.vue?vue&type=script&lang=js"

import "./EdiSelector.vue?vue&type=style&index=0&id=3f2743d8&scoped=true&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2743d8"]])

export default __exports__